import { render, staticRenderFns } from "./RoleManager.vue?vue&type=template&id=b07106ca&scoped=true&"
import script from "./RoleManager.vue?vue&type=script&lang=js&"
export * from "./RoleManager.vue?vue&type=script&lang=js&"
import style0 from "./RoleManager.vue?vue&type=style&index=0&id=b07106ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07106ca",
  null
  
)

export default component.exports